import * as React from "react";
const SvgGreenCheckCircle = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 18, height: 18, rx: 9, fill: "#008400" }), /* @__PURE__ */ React.createElement("path", { d: "M5.21875 9.57812L7.5625 11.9219L13.0312 6.45312", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", style: {
  fill: "#008400",
  stroke: "white"
} }));
export default SvgGreenCheckCircle;
